import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { t } from "i18next";

interface ISubmitButtonProps {
    label?: string;
    submitting?: boolean;
}

type SubmitButtonProps = ISubmitButtonProps & ButtonProps;

function SubmitButton({ label = t("common.save"), submitting = false, disabled, ...rest }: SubmitButtonProps) {
    return <Button type="submit" variant="contained" disabled={submitting || disabled} {...rest}>{submitting ? t("common.loading") : label}</Button>;
}

export { SubmitButton };
